var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M7.33 3.254v1.2H2v12.8h14.624v-6.4h1.2v6.5c0 .565-.426 1.033-.975 1.093l-.12.007H1.894c-.565 0-1.028-.431-1.088-.98l-.006-.12v-13c0-.566.425-1.034.975-1.094l.12-.006h5.434zM15.394.548L19.911 4.5l-4.516 3.952-.79-.904L17.402 5.1l-2.976.001c-2.773 0-4.719 1.953-4.822 4.63l-.004.225v.545H8.4v-.545c0-3.366 2.389-5.936 5.788-6.051l.238-.004h2.976l-2.797-2.448.79-.904z"
  })));
}
export default SvgCommonIconShare;